export default __webpack_public_path__ + "static/media/arrow-left.af129e3c.svg";